import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isValid", "isError", "errorMessage", "fullWidth", "label", "note", "hideNoteSpace", "options", "onChange", "value", "ownAnswer"],
  _excluded2 = ["label"],
  _excluded3 = ["onTextChange", "getCheckboxOnChange", "getActive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Field } from '@vtblife/uikit/dist/legacy';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { Checkbox, Input } from '@vtblife/uikit';
import styles from './formik-checkbox-group-field.module.css';
var CheckboxGroupFilteredProps = function CheckboxGroupFilteredProps(props) {
  // Skip some of params to be passed by Field to CheckboxGroup
  var isValid = props.isValid,
    isError = props.isError,
    errorMessage = props.errorMessage,
    fullWidth = props.fullWidth,
    label = props.label,
    note = props.note,
    hideNoteSpace = props.hideNoteSpace,
    options = props.options,
    onChange = props.onChange,
    arrValues = props.value,
    ownAnswer = props.ownAnswer,
    rest = _objectWithoutProperties(props, _excluded);
  var getCheckboxOnChange = useCallback(function (value) {
    return function (_checked, event) {
      if (onChange) {
        var newValues = arrValues;
        if (_checked && !arrValues.includes(value)) {
          newValues = [].concat(_toConsumableArray(arrValues), [value]);
        } else {
          newValues = arrValues.filter(function (val) {
            return val !== value;
          });
        }
        onChange(newValues, event);
      }
    };
  }, [onChange, arrValues]);
  var items = options.map(function (option, i) {
    return React.createElement(CheckboxComponent, _objectSpread(_objectSpread({}, rest), {}, {
      key: i,
      label: option.label,
      onChange: getCheckboxOnChange(option.value),
      value: arrValues.includes(option.value)
    }));
  });
  return React.createElement("div", null, items, ownAnswer && React.createElement(OwnAnswerCheckbox, _objectSpread(_objectSpread({}, rest), {}, {
    key: 'ownAnswer',
    onTextChange: function onTextChange(_ref) {
      var value = _ref.currentValue,
        prevValue = _ref.prevValue,
        event = _ref.event;
      var newValues = arrValues.filter(function (val) {
        return val !== prevValue;
      });
      if (!arrValues.includes(value)) {
        newValues = [].concat(_toConsumableArray(newValues), [value]);
      } else {
        newValues = newValues.filter(function (val) {
          return val !== value;
        });
      }
      onChange(newValues, event);
    },
    getCheckboxOnChange: getCheckboxOnChange,
    getActive: function getActive(text) {
      return arrValues.includes(text);
    }
  })));
};
export function CheckboxComponent(props) {
  var label = props.label,
    rest = _objectWithoutProperties(props, _excluded2);
  return React.createElement("div", {
    className: styles.checkboxItem
  }, React.createElement(Checkbox, _objectSpread({}, rest), React.createElement("div", {
    className: styles.label
  }, label)));
}
export function OwnAnswerCheckbox(props) {
  var onTextChange = props.onTextChange,
    getCheckboxOnChange = props.getCheckboxOnChange,
    getActive = props.getActive,
    rest = _objectWithoutProperties(props, _excluded3);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var isActive = getActive(text);
  var inputRef = useRef();
  useEffect(function () {
    var _a;
    if (isActive) {
      (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [isActive]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    key: 'ownAnswerCheckbox',
    className: styles.checkboxItem
  }, React.createElement(CheckboxComponent, _objectSpread(_objectSpread({}, rest), {}, {
    label: 'Свой вариант',
    onChange: getCheckboxOnChange(text),
    value: isActive
  }))), isActive && React.createElement("div", {
    key: 'ownAnswerText',
    className: styles.checkboxItem
  }, React.createElement(Input, {
    min: 1,
    type: "text",
    onChange: function onChange(value, event) {
      var currentValue = value.toString();
      onTextChange({
        currentValue: currentValue,
        prevValue: text,
        event: event
      });
      setText(currentValue);
    },
    value: text || '',
    size: "l",
    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442",
    inputRef: inputRef
  })));
}
export var CheckboxGroupField = Field(CheckboxGroupFilteredProps, false, false);
export var FormikCheckboxGroupField = createFormikComponent(CheckboxGroupField, mapFieldToInputProps);